import { render, staticRenderFns } from "./MenOfIntegrity.vue?vue&type=template&id=21f8a5c5&"
import script from "./MenOfIntegrity.vue?vue&type=script&lang=js&"
export * from "./MenOfIntegrity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports